import { render, staticRenderFns } from "./ProducerImportModal.html?vue&type=template&id=4b6dc170&scoped=true&external"
import script from "./ProducerImportModal.ts?vue&type=script&lang=ts&external"
export * from "./ProducerImportModal.ts?vue&type=script&lang=ts&external"
import style0 from "./ProducerImportModal.css?vue&type=style&index=0&id=4b6dc170&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6dc170",
  null
  
)

export default component.exports